import { useQuery } from '@tanstack/react-query'
import { expensesApi } from '../../api/expensesApi'

export const usePublicExpenseQuery = (token: string, enabled: boolean) =>
  useQuery({
    queryKey: ['public-expense', token],
    queryFn: () => expensesApi.getExpenseByToken(token).then((r) => r.data),
    enabled,
    retry: false,
    staleTime: Infinity,
  })
